import React from 'react';
import { normaliseTheme } from '../../../themes';
import { PRESET_COLOURS, initials } from '../../../lib/shopProfile/helpers';

export const LogoBrandPanel = ({
  form, onChange, logoUploading, logoInputRef, handleLogoFile,
}) => (
  <div className="panel" style={{ padding: 18, marginBottom: 14 }}>
    <div className="field">
      <label>Logo &amp; brand colour</label>
      <div className="uploads">
        <div
          className="logo-up"
          style={form.logo_url ? { backgroundImage: `url(${form.logo_url})`, color: 'transparent' } : {}}
          data-testid="logo-preview"
        >
          {!form.logo_url && initials(form.name).charAt(0)}
        </div>
        <label className={`drop ${logoUploading ? 'uploading' : ''}`} data-testid="logo-drop">
          {logoUploading ? 'Uploading…' : (
            <>
              Drop a logo or <b>browse</b><br />
              <span style={{ fontSize: 11 }}>PNG or SVG · square works best</span>
            </>
          )}
          <input
            ref={logoInputRef}
            type="file"
            accept="image/png,image/jpeg,image/svg+xml,image/webp"
            onChange={(e) => handleLogoFile(e.target.files?.[0])}
            data-testid="logo-input"
          />
        </label>
      </div>
    </div>
    {normaliseTheme(form.theme) === 'instacut-default' && (
      <div className="field" style={{ marginBottom: 0 }}>
        <label style={{ marginBottom: 9 }}>Accent colour <small style={{ color: 'var(--mute)', fontWeight: 400 }}>Only editable on the Instacut default theme — locked themes use their own palette.</small></label>
        <div className="colorrow">
          {PRESET_COLOURS.map(c => (
            <span
              key={c}
              className={`swatch ${form.accent_colour?.toLowerCase() === c.toLowerCase() ? 'on' : ''}`}
              style={{ background: c }}
              onClick={() => onChange({ accent_colour: c })}
              data-testid={`swatch-${c.replace('#', '')}`}
            />
          ))}
          <input
            type="text"
            className="hex-input"
            value={form.accent_colour}
            onChange={(e) => onChange({ accent_colour: e.target.value })}
            placeholder="#hex"
            data-testid="hex-input"
          />
        </div>
      </div>
    )}
  </div>
);
